import { useEffect, useRef, useState } from 'react';
import { BaseButton } from '@repo/common';
import { toNewDomain } from '../../utils/brand';

const MigrationBottomSheet = ({ onClose }) => {
  const hero = `${process.env.REACT_APP_ASSETS_URL}/img-migration-modal.svg`;
  const [dragY, setDragY] = useState(0);
  const dragStartRef = useRef(null);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  const handleDragStart = (e) => {
    dragStartRef.current = e.touches ? e.touches[0].clientY : e.clientY;
  };

  const handleDragMove = (e) => {
    if (dragStartRef.current == null) return;
    const y = e.touches ? e.touches[0].clientY : e.clientY;
    setDragY(Math.max(0, y - dragStartRef.current));
  };

  const handleDragEnd = () => {
    if (dragStartRef.current == null) return;
    dragStartRef.current = null;
    if (dragY > 100) {
      onClose?.();
    } else {
      setDragY(0);
    }
  };

  return (
    <div
      className='fixed inset-0 z-[9999] flex items-end bg-surface-black40'
      onClick={onClose}
    >
      <div
        className='w-full bg-grayscale-gray00 rounded-t-[40px] animate-slideUp'
        onClick={(e) => e.stopPropagation()}
        style={{
          transform: `translateY(${dragY}px)`,
          transition:
            dragStartRef.current == null ? 'transform 0.2s ease' : 'none',
        }}
      >
        {/* 핸들 */}
        <div
          className='flex pt-4 pb-[50px] cursor-grab touch-none'
          onTouchStart={handleDragStart}
          onTouchMove={handleDragMove}
          onTouchEnd={handleDragEnd}
          onMouseDown={handleDragStart}
          onMouseMove={handleDragMove}
          onMouseUp={handleDragEnd}
          onMouseLeave={handleDragEnd}
        >
          <div className='mx-auto h-[6px] w-[46px] rounded-full bg-grayscale-gray02' />
        </div>

        <div className='flex flex-col items-center px-10 pb-8 text-center'>
          <div className='flex flex-col items-center gap-3 text-center pb-[50px]'>
            <img src={hero} alt='O!ng Lab is now Koready' />

            <p className='typo-b14Strong text-text-primary'>
              O!ng Lab is now{' '}
              <a href={toNewDomain('/')} className='underline'>
                Koready
              </a>
              .
              <br />
              Your account, including all past reservations and personal data,
              has been seamlessly migrated to our new domain. Please bookmark
              our new address for future visits! Note that this old site will
              officially shut down on August 31, 23:59:59.
            </p>

            <p className='typo-b14 text-text-secondary'>
              Need help?
              <br />
              Reach out to{' '}
              <a href='mailto:hello@ko-ready.com' className='underline'>
                hello@ko-ready.com
              </a>
            </p>
          </div>

          <div className='w-full'>
            <BaseButton
              type='primary'
              size='l'
              hideIcon
              width='100%'
              onClick={() => {
                window.location.href = toNewDomain();
              }}
            >
              Go to New Website
            </BaseButton>
          </div>

          <BaseButton
            type='text'
            onClick={onClose}
            size='l'
            hideIcon
            width='100%'
          >
            stay
          </BaseButton>
        </div>
      </div>
    </div>
  );
};

export default MigrationBottomSheet;
